import merchy from './merchy';

export default {
  merchy,
};
